export enum I18nNamespace {
  COMMON = "common",
  CAREER = "career",
  COUNTRY = "country",
  DOCUMENT = "document",
}
